module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.f3351fb.woff";